import { useEffect, useState } from 'react';

const useObservable = ({ ref, rootMargin = '0px', threshold = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!isVisible) setIsVisible(true);
        } else {
          if (isVisible) setIsVisible(false);
        }
      });
    };

    const observerOptions = { rootMargin, threshold };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(node);
    return () => observer.unobserve(node);
  }, [ref, isVisible, rootMargin, threshold]);

  return isVisible;
};

export default useObservable;
